import React from 'react';
import { Typography } from '@otp/ui';
import { StoreModel } from 'src/graphql/generated/graphql';
import Grid from '@mui/material/Grid';
import { getAddress } from 'src/utils/restaurant-data';

export const RestaurantListItem = ({
  restaurant,
  isLast,
}: {
  restaurant: Partial<StoreModel>;
  isLast: Boolean;
}) => {
  return (
    <>
      <Grid container alignItems="center">
        <Grid container item xs={9} direction="column">
          <Typography
            variant="subtitle1"
            className="rounded-3xl fontWeight-bold font-semibold"
          >
            {restaurant.name}
          </Typography>
          <Typography variant="subtitle2" className="text-gray-600">
            {getAddress(restaurant)}
          </Typography>
        </Grid>
        <Grid item xs={3} container justifyContent="flex-end">
          <Typography
            variant="subtitle2"
            className="text-white bg-blue-500 px-3 py-1 rounded-full"
          >
            {restaurant.nationalStoreNumber}
          </Typography>
        </Grid>
      </Grid>
      {!isLast && <div className="w-full h-[1.5px] bg-gray-400/40" />}
    </>
  );
};
